<div class="card">
  <div class="card-header card-no-border pb-0">
    <div class="header-top">
      <h5>{{ 'Budget Metrics' | translate }}</h5>
      <div class="dropdown icon-dropdown">
        <button class="btn dropdown-toggle" type="button" (click)="toggle()">
          <app-feather-icons [icon]="'more-horizontal'"></app-feather-icons>
        </button>
        <div class="dropdown-menu dropdown-menu-end" [class.show]="show">
          <a class="dropdown-item" href="#">{{ 'Weekly' | translate }}</a>
          <a class="dropdown-item" href="#">{{ 'Monthly' | translate }}</a>
          <a class="dropdown-item" href="#">{{ 'Yearly' | translate }}</a>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body py-lg-3">
    <ul class="user-list">
      <li>
        <div class="user-icon primary">
          <div class="user-box"><i class="font-primary" data-feather="users"></i></div>
        </div>
        <div>
          <h5 class="mb-1">{{ '$20000k Allocated' | translate }}</h5> <!-- Example metric; update as needed -->
          <span class="font-primary d-flex align-items-center">
            <i class="icon-arrow-up icon-rotate me-1"></i>
            <span class="f-w-500">{{ '+15.23%' | translate }}</span> <!-- Example percentage; update as needed -->
          </span>
        </div>
      </li>
      <li>
        <div class="user-icon success">
          <div class="user-box"><i class="font-success" data-feather="user-minus"></i></div>
        </div>
        <div>
          <h5 class="mb-1">{{ '$1000k Used' | translate }}</h5> <!-- Example metric; update as needed -->
          <span class="font-danger d-flex align-items-center">
            <i class="icon-arrow-down icon-rotate me-1"></i>
            <span class="f-w-500">{{ '-10.00%' | translate }}</span> <!-- Example percentage; update as needed -->
          </span>
        </div>
      </li>
    </ul>
  </div>
</div>
